import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../config/firebase-config';

export const updateResellerGroupIds = async (identity, context = {}) => {
  if (!identity?.resellerId && !identity?.email) {
    return { success: 'no', message: 'resellerId es requerido' };
  }

  try {
    const updateGroupIdsFn = httpsCallable(functions, 'updateResellerGroupIdsV2');
    const result = await updateGroupIdsFn({
      resellerId: identity.resellerId,
      email: identity.email,
      ...context,
      requestedApp: context.requestedApp || 'dealership_web',
    });
    return result.data;
  } catch (error) {
    console.error('Error actualizando groupIds del reseller:', error);
    return { success: 'no', message: error.message };
  }
};
